import './ticket-meta.less';
import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router';
import qs from 'qs';

import avatars from '../../../config/avatars';
import TicketMetaForm from './ticket-meta-form';

const TicketMeta = ({
	data,
	affiliateLevelList,
	affiliate,
	intl,
	loginWithAffiliate,
	submitOfferAccess,
	changeAffiliateLevel,
	pendingOfferAccessRequests,
	ticketMetaFormValue,
	rejectOfferAccess,
	can,
	toggleCloseForm
}) => (
	<div className="thread-container">
		<div className="container__content-title">
			<div className="container__content-title-position" />
		</div>
		<div className="support__meta">
			<div className="support__meta-content">
				<div className="info">
					<p className="info__title">{intl('Ticket')}</p>
					<p className="info__number">{ data.id}</p>
				</div>

				<p className="theme">{ data.title }</p>

				<div className="control">
					{can('viewAffiliates') && <div className="control__item affiliate">
						<div className="affiliate__avatar">
							<img src={ affiliate.avatar
								? affiliate.avatar
								: avatars.affiliateSmall
							} alt="avatar"/>
						</div>
						<div className="affiliate__info">
							<p className="email">{ affiliate.email }</p>
							<p className="id">{ affiliate.id }</p>
						</div>
					</div>}

					{can('viewAffiliates') && <div className="control__item">
						<Link
							to={`threads/?${getAffiliateQuery(affiliate)}`}
							className="link icon-tickets">{intl(`All tickets from affiliate`)}</Link>
					</div>}

					{can('viewAnalytics') && <div className="control__item">
						<Link
							to={`statistics/?${getAffiliateQuery(affiliate)}`}
							className="link icon-statistics">{intl(`Affiliate statistics`)}</Link>
					</div>}

					{can('login') && <div className="control__item">
						<a
							href="#"
							className="link icon-login"
							onClick={ e => {
								e.preventDefault();
								loginWithAffiliate(affiliate.id);
							}}>{intl('Log in as a affiliate')}</a>
					</div>}

					{can('viewAffiliates') && <div className="control__item">
						<Link
							to={`affiliates/profile/${affiliate.id}`}
							className="link icon-profile">{intl('Affiliate profile')}</Link>
					</div>}
				</div>
			</div>

			<TicketMetaForm
				affiliate={affiliate}
				affiliateLevelList={affiliateLevelList}
				pendingOfferAccessRequests={pendingOfferAccessRequests}
				intl={intl}
				submitForm={submitOfferAccess}
				changeAffiliateLevel={changeAffiliateLevel}
				ticketMetaFormValue={ticketMetaFormValue}
				rejectOfferAccess={rejectOfferAccess}
				toggleCloseForm={toggleCloseForm}
				isClosed={data.status === 'closed'}
				isGiftOrder={data.category === 'gift_order'}
				category={data.category}
				can={can}/>
		</div>
	</div>
);

TicketMeta.propTypes = {
	data: propTypes.object,
	affiliateLevelList: propTypes.array,
	affiliate: propTypes.object,
	intl: propTypes.func,
	loginWithAffiliate: propTypes.func,
	submitOfferAccess: propTypes.func,
	changeAffiliateLevel: propTypes.func,
	pendingOfferAccessRequests: propTypes.array,
	ticketMetaFormValue: propTypes.object,
	rejectOfferAccess: propTypes.func,
	can: propTypes.func,
	toggleCloseForm: propTypes.func
};

const getAffiliateQuery = affiliate => {
	const query = {
		filters: { affiliates: [affiliate.id] }
	};
	const entity = {
		filters: [{
			name: 'affiliates',
			values: [{ value: affiliate.id, label: affiliate.email }]
		}]
	};

	return qs.stringify({
		query,
		entity
	});
};

export default TicketMeta;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/ticket-meta.js